import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import { VpIcon } from '../../';

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (props) => props !== 'isExpired'
})(({ theme, isExpired }) => ({
  height: '75px',
  cursor: 'pointer',

  ...(isExpired && {
    cursor: 'not-allowed',
    '& td': {
      color: theme.palette.vpColors.blueMain
    }
  })
}));

export const StyledIcon = styled(VpIcon)({
  width: '16px',
  height: '16px',
  marginLeft: '11px',
  marginTop: '5px'
});

export const StyledChevronIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.vpColors.grey,
  zIndex: '5'
}));

export const StyledTableCell = styled(TableCell)({
  padding: 0
});



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/styles.js